module.exports = __webpack_public_path__ + "img/right_worm_n3_2.prt.8017031a.jpg";